export class ProjectRepartition {
  project_id: string;
  gross_amount: number;
  project_name: string;

  constructor() {
    this.gross_amount = 0;

    this.project_name = "";
  }

  public static createInstance(jsonData: ProjectRepartition): ProjectRepartition {
    const c = Object.assign(new ProjectRepartition(), jsonData);

    return c;
  }

  public static createInstances(jsonData: ProjectRepartition[]): ProjectRepartition[] {
    return jsonData.map(ProjectRepartition.createInstance);
  }
}
